// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tJ10r","question":"styles_question__fUMbk","inputVisibleButton":"styles_inputVisibleButton__gXQ5C","note":"styles_note__3zL-Y"};